// extracted by mini-css-extract-plugin
module.exports = {"highlight__section":"styles_highlight__section__hHn4y","highlight__item":"styles_highlight__item__lZs6o"};